import { useEffect, useState } from 'react';
import { filterBy, TSortTypes } from 'pages/ImageManagement/contants';
import { TPictures } from 'core/API/picturesApi';
import { groupBy, orderBy } from 'lodash';
import { entries } from 'utils/wrappers';

export const getImageByFilters = (
    allPictures: TPictures[],
    {
        inputFilter = '',
        filters = {},
    }: {
        inputFilter?: string;
        filters?: Partial<TPictures>;
    },
    getLength?: boolean,
) => {
    const regex = new RegExp(inputFilter, 'i');
    const { isAll, retailers_id, ...nativeFilters } = filters;

    const filteredPictures = allPictures?.filter((picture: TPictures) => {
        const testInputFilter = !inputFilter || filterBy.find((key) => regex.test(`${picture[key]}`));
        const filtersEntries = entries(nativeFilters);
        const testCheckedFilters =
            !filtersEntries.length ||
            filtersEntries.filter(([k, v]) => v === undefined || `${picture[k]}` === `${v}`).length ===
                filtersEntries.length;
        const checkRetailer = true;
        // @TODO other ticket
        // !retailers ||
        //     picture.retailers?.length === 0 ||
        //     retailers?.filter((retailer) => picture.retailers?.includes(retailer)).length;

        return testInputFilter && testCheckedFilters && checkRetailer;
    });

    return getLength ? filteredPictures.length : filteredPictures;
};

const useGetFilteredPictures = ({
    allPictures,
    choosenSort,
    isAscendingOrder = true,
    inputFilter = '',
    filters = {},
}: {
    allPictures: TPictures[];
    choosenSort?: TSortTypes;
    isAscendingOrder?: boolean;
    inputFilter?: string;
    filters?: Partial<TPictures>;
}) => {
    const [imageList, setImageList] = useState<TPictures[][]>([]);

    useEffect(() => {
        const filteredPictures = getImageByFilters(allPictures, { inputFilter, filters });
        const groupedPictures = Object.values(groupBy(filteredPictures as TPictures[], 'ean'));

        const finalPicture = choosenSort?.filterKey
            ? orderBy(
                  groupedPictures,
                  (picture) =>
                      choosenSort.filterKey === 'nbPictures' ? picture.length : picture[0][choosenSort.filterKey],
                  isAscendingOrder ? 'asc' : 'desc',
              )
            : groupedPictures;

        setImageList(finalPicture);
    }, [allPictures, isAscendingOrder, choosenSort, filters, inputFilter]);

    return { imageList };
};

export default useGetFilteredPictures;
